import React, { useState, useEffect, useRef } from "react";
import { connect } from "react-redux";
import {
    setPageTitle,
    toggleNavigation,
    setMessage,
    setBreadCrum,
} from "../../../store/Page";
const OutboundCampaignFilter = (props) => {
    const [state, setState] = useState({
        search: ''
    });
    const searchTimeoutRef = useRef(null);

    const safeSubmitFilter = (filterType, value) => {
        if (props && props.onSubmitFilter && typeof props.onSubmitFilter === 'function') {
            props.onSubmitFilter(filterType, value);
        }
    };



    // Cleanup timeout on unmount
    useEffect(() => {
        return () => {
            if (searchTimeoutRef.current) {
                clearTimeout(searchTimeoutRef.current);
            }
        };
    }, []);


    const handleSearchChange = (e) => {
        try {
            if (e && e.target && e.target.value !== undefined) {
                const searchValue = e.target.value;
                setState(prev => ({ ...prev, search: searchValue }));

                // Clear existing timeout
                if (searchTimeoutRef.current) {
                    clearTimeout(searchTimeoutRef.current);
                }

                // Set new timeout for debounced search
                searchTimeoutRef.current = setTimeout(() => {
                    if (searchValue.length >= 2 || searchValue.length === 0) {
                        safeSubmitFilter('q', searchValue);
                    }
                }, 500); // 500ms debounce delay
            }
        } catch (error) {
            console.error('Error in handleSearchChange:', error);
        }
    };

    const handleSearchSubmit = (e) => {
        if (e) {
            e.preventDefault();
        }
        safeSubmitFilter('q', state.search);
    };
    try {
        return (
            <form id="searchcampaign" method="post" onSubmit={(e) => {
                e.preventDefault();
                handleSearchSubmit(e);
            }}>
                <div>
                    <div className="kt-input-icon kt-input-icon--right header-search kt-input-icon--right">
                        <input
                            type="text"
                            className="form-control"
                            placeholder="Search..."
                            id="generalSearch"
                            name="q"
                            value={state.search || ''}
                            onChange={(e) => handleSearchChange(e)}
                        />
                        <span className="kt-input-icon__icon kt-input-icon__icon--right">
                            <span><i className="la la-search"></i></span>
                        </span>
                    </div>
                </div>
            </form>
        );
    } catch (error) {
        console.error('Error in OutboundCampaignFilter:', error);
        return (
            <div className="kt-portlet__body px-0" style={{ paddingTop: 0 }}>
                <div className="alert alert-danger">
                    Error loading filter component. Please refresh the page.
                </div>
            </div>
        );
    }
};

const mapStateToProps = (state) => ({
    user: state.user.company ? state.user.company : null,
});

const mapDispatchToProps = {
    setPageTitle,
    toggleNavigation,
    setMessage,
    setBreadCrum,
};

export default connect(mapStateToProps, mapDispatchToProps)(OutboundCampaignFilter); 